module.exports = __webpack_public_path__ + "img/ZhongkeBrain.d1d36b55.jpg";